import { BaseControlledModal } from "../../../../../../common/components/base_controlled_modal";
import DefaultInput from "../../../../../../common/components/default_input";
import { GestaoDistribuicaoEpi } from "../../../../domain/models/gestao_distribuicao_epi";

import dayjs from "dayjs";
type Props = {
  open: boolean;
  loading: boolean;
  imagemUrl: string | null;
  selectedDistribuicaoEpi: GestaoDistribuicaoEpi | null;
  onClose: () => void;
};

export const VisualizacaoBiometriaModal = ({
  open,
  loading,
  imagemUrl,
  selectedDistribuicaoEpi,
  onClose,
}: Props) => {
  const formatarData = (data?: Date | string | null) => {
    return data ? dayjs(data).format("DD/MM/YYYY") : "";
  };

  const formatarHora = (hora?: string | null) => {
    return hora ? hora.toString().substring(0, 8) : "";
  };

  return (
    <BaseControlledModal
      open={open}
      saving={false}
      loading={loading}
      title="Confirmação de recebimento"
      width="650px"
      onClose={onClose}
    >
      <div className="w-full flex flex-col gap-4 p-4 bg-gray-50 min-h-[300px] rounded-md mt-4">
        {loading ? (
          <span className="text-gray-500 text-center">
            Carregando imagem...
          </span>
        ) : imagemUrl ? (
          <>
            <div className="flex flex-col gap-4 w-full">
              
              <div className="flex flex-row gap-4 w-full">
                <div className="flex-1">
                  <DefaultInput
                    name="Funcionario"
                    label="Funcionário"
                    value={
                      selectedDistribuicaoEpi?.funcionario?.toString() || ""
                    }
                    readOnly={true}
                  />
                </div>
                <div className="flex-1">
                  <DefaultInput
                    name="VerificadorPor"
                    label="Verificado Por"
                    value={
                      selectedDistribuicaoEpi?.nomeVerificadoPor?.toString() || ""
                    }
                    readOnly={true}
                  />
                </div>
              </div>

              {/* SEGUNDA LINHA: Data e Hora */}
              <div className="flex flex-row gap-4 w-full">
                <div className="flex-1">
                  <DefaultInput
                    name="DataAssinatura"
                    label="Data Assinatura"
                    value={formatarData(selectedDistribuicaoEpi?.dataAssinatura)}
                    readOnly={true}
                  />
                </div>
                <div className="flex-1">
                  <DefaultInput
                    name="HoraAssinatura"
                    label="Hora Assinatura"
                    value={formatarHora(selectedDistribuicaoEpi?.horaAssinatura)}
                    readOnly={true}
                  />
                </div>
              </div>
            </div>

            <div className="flex justify-center w-full mb-2">
              <img
                src={imagemUrl}
                alt="Biometria do Funcionário"
                className="max-w-full max-h-[40vh] object-contain rounded-md shadow-sm"
              />
            </div>
          </>
        ) : (
          <span className="text-gray-500 text-center flex-1 flex items-center justify-center h-full">
            Nenhuma imagem disponível para validação.
          </span>
        )}
      </div>
    </BaseControlledModal>
  );
};
